import React from "react"
import {
  Box,
  ControlBox,
  ControlBoxProps,
  Text,
  VisuallyHidden,
} from "@chakra-ui/react"
import colors from "@constants/colors"
import { FormCheckmark } from "@components/universal/icons"

interface CheckboxInputProps extends Omit<ControlBoxProps, "children"> {
  name: string
  label: string
  isChecked?: boolean
  isDisabled?: boolean
}

const CheckboxInput: React.FC<CheckboxInputProps> = ({
  name,
  label,
  isChecked,
  isDisabled,
  onChange,
}) => {
  return (
    <Box
      as="label"
      alignItems="center"
      display="flex"
      cursor={isDisabled ? "not-allowed" : "pointer"}
      _notLast={{ m: "4px 0" }}
    >
      <VisuallyHidden
        as="input"
        // @ts-ignore
        type="checkbox"
        name={name}
        value={label}
        checked={isChecked}
        disabled={isDisabled}
        onChange={onChange}
      />
      <ControlBox
        h="26px"
        w="26px"
        border="solid 1px #B1B5B8"
        borderRadius="6px"
        bg="white"
        _disabled={{
          bg: "disabled",
        }}
        _focus={{
          bg: "midLight",
        }}
        _hover={{
          bg: "midAccessible",
        }}
        _checked={{
          bg: "dark",
        }}
        _checkedAndHover={{
          bg: "midAccessible",
        }}
        _checkedAndDisabled={{
          bg: "disabled",
          outline: "1px",
        }}
      >
        <FormCheckmark />
      </ControlBox>
      <Text
        as="span"
        pl="8px"
        fontFamily="Avenir"
        fontSize="13.5px"
        fontWeight="400"
        lineHeight="16px"
        color={colors.dark}
      >
        {label}
      </Text>
    </Box>
  )
}

export default CheckboxInput
